export const miscellaneousReducer = (state = {loading: true, titles: [], towns: [], provinces: [], subjects: [], levels: [] } , action) => {
    switch (action.type) {
        case 'MISCELLANEOUS_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'MISCELLANEOUS_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        case 'MISCELLANEOUS_GET_TITLES_SUCCESS':
            return {
                ...state,
                loading: false,
                titles: action.payload
            }
        case 'MISCELLANEOUS_GET_TOWNS_SUCCESS':
            return {
                ...state,
                loading: false,
                towns: action.payload
            }
        case 'MISCELLANEOUS_GET_PROVINCES_SUCCESS':
            return {
                ...state,
                loading: false,
                provinces: action.payload
            }
        case 'MISCELLANEOUS_GET_SUBJECTS_SUCCESS':
            return {
                ...state,
                loading: false,
                subjects: action.payload
            }
        case 'MISCELLANEOUS_GET_LEVELS_SUCCESS':
            return {
                ...state,
                loading: false,
                levels: action.payload
            }
        default:
            return state
    }
}

